(function() {
  'use strict';

  if (window.self !== window.top) return;

  var DRAWER_SELECTORS = ['#sidebar-cart', '#dropdown-cart'];

  function shouldConvert() {
    return typeof Currency !== 'undefined' &&
      typeof Currency.convertAll === 'function' &&
      typeof Currency.currentCurrency !== 'undefined' &&
      Currency.currentCurrency &&
      typeof window.shop_currency !== 'undefined' &&
      Currency.currentCurrency !== window.shop_currency;
  }

  function getActiveCurrency() {
    var active = document.querySelector('#currencies .active');
    if (active && active.getAttribute('data-currency')) {
      return active.getAttribute('data-currency');
    }
    return (typeof Currency !== 'undefined' && Currency.currentCurrency) || null;
  }

  function convertDrawers() {
    if (!shouldConvert()) return;
    var target = getActiveCurrency();
    if (!target) return;
    DRAWER_SELECTORS.forEach(function(sel) {
      try {
        Currency.convertAll(window.shop_currency, target, sel + ' span.money', 'money_format');
      } catch (e) {}
    });
  }

  var pendingTimer = null;
  function scheduleConvert(delay) {
    if (pendingTimer) clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function() {
      pendingTimer = null;
      convertDrawers();
    }, delay || 100);
  }

  function bindAjax() {
    if (!window.jQuery || !window.jQuery.fn) return false;
    window.jQuery(document).ajaxSuccess(function(event, xhr, settings) {
      if (!settings || !settings.url) return;
      var u = settings.url;
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u) ||
          /\/cart(\.js)?(\?|$)/.test(u) ||
          /\?view=cart_edit/.test(u) ||
          /\/products\/[^?]+\.js/.test(u)) {
        scheduleConvert(80);
        scheduleConvert(400);
        scheduleConvert(1200);
      }
    });
    return true;
  }

  function setupDrawerObservers() {
    var found = 0;
    DRAWER_SELECTORS.forEach(function(sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      found++;
      if (el.__cdcfObserved) return;
      el.__cdcfObserved = true;
      var obs = new MutationObserver(function() {
        scheduleConvert(120);
      });
      obs.observe(el, { childList: true, subtree: true });
    });
    return found > 0;
  }

  function init() {
    bindAjax();
    if (!setupDrawerObservers()) {
      var attempts = 0;
      var iv = setInterval(function() {
        attempts++;
        if (setupDrawerObservers() || attempts > 30) clearInterval(iv);
      }, 500);
    }
    scheduleConvert(200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
